'use client';

import React from 'react';

import { allFlags } from '@/flags';

import { FlagsProvider } from './provider';

interface FlagsProviderWrapperProps {
  children: React.ReactNode;
}

export function FlagsProviderWrapper( { children }: FlagsProviderWrapperProps ) {
  return (
    <FlagsProvider flags={ allFlags }>
      { children }
    </FlagsProvider>
  );
}
